/* CustomOption.tsx generated by @compiled/babel-plugin v0.26.0 */
import _extends from "@babel/runtime/helpers/extends";
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import { Box, Inline, Stack, xcss } from '@atlaskit/primitives';
import { CheckboxOption, components, RadioOption } from '@atlaskit/select';
import React from 'react';
const resultsCountTextStyles = xcss({
  color: 'color.text.subtlest',
  fontSize: '0.75rem'
});
const descriptionTextStyles = xcss({
  color: 'color.text.subtlest',
  fontSize: '0.75rem'
});
const optionWrapperStyles = xcss({
  // Enable wrapping text within the option container
  whiteSpace: 'normal',
  color: 'color.text'
});
const optionSelectedStyles = xcss({
  color: 'color.text.selected'
});
const iconBeforeStyles = xcss({
  // Prevent the icon from shrinking when the sibling flex items are too wide
  flexShrink: 0
});
const iconAfterStyles = xcss({
  // Allow flex item to grow so we align it in the center of the remaining space
  flexGrow: 1
});
/**
 * Separate `Internal` component created for the custom UI, to make it easier to test.
 * `CustomOption` is passed to react select, and requires additional props that are
 * internally used by react select, so is difficult to test.
 */
export const CustomOptionInternal = _ref => {
  let {
    label,
    resultsCount,
    description,
    iconBefore,
    iconAfter,
    isSelected
  } = _ref;
  return /*#__PURE__*/React.createElement(Inline, {
    spread: "space-between",
    space: "space.100",
    alignBlock: "center",
    xcss: [optionWrapperStyles, isSelected && optionSelectedStyles]
  }, /*#__PURE__*/React.createElement(Inline, {
    space: "space.100",
    alignBlock: "center",
    grow: "fill"
  }, iconBefore && /*#__PURE__*/React.createElement(Inline, {
    xcss: iconBeforeStyles
  }, iconBefore), /*#__PURE__*/React.createElement(Stack, null, /*#__PURE__*/React.createElement(Box, null, label), description && /*#__PURE__*/React.createElement(Box, {
    xcss: descriptionTextStyles
  }, description)), iconAfter && /*#__PURE__*/React.createElement(Inline, {
    alignInline: "center",
    xcss: iconAfterStyles
  }, iconAfter)), resultsCount !== undefined && /*#__PURE__*/React.createElement(Box, {
    xcss: resultsCountTextStyles
  }, "[", resultsCount, "]"));
};
const multiSelectDesktopStyles = xcss({
  paddingBlock: 'space.075'
});
const singleSelectDesktopStyles = xcss({
  paddingBlock: 'space.050'
});
const mobileWrapperStyles = xcss({
  paddingBlock: 'space.150'
});
const isMulti = props => props.selectProps.isMulti;
export const CustomOption = props => isMulti(props) ? /*#__PURE__*/React.createElement(CheckboxOption, props, /*#__PURE__*/React.createElement(Box, {
  xcss: multiSelectDesktopStyles
}, /*#__PURE__*/React.createElement(CustomOptionInternal, props.data))) : /*#__PURE__*/React.createElement(components.Option, props, /*#__PURE__*/React.createElement(Box, {
  xcss: singleSelectDesktopStyles
}, /*#__PURE__*/React.createElement(CustomOptionInternal, _extends({}, props.data, {
  isSelected: props.isSelected
}))));
export const CustomOptionMobile = props => isMulti(props) ? /*#__PURE__*/React.createElement(CheckboxOption, props, /*#__PURE__*/React.createElement(Box, {
  xcss: mobileWrapperStyles
}, /*#__PURE__*/React.createElement(CustomOptionInternal, props.data))) :
/*#__PURE__*/
/**
 * Type cast is required as RadioOption doesn't support generic types in the current version of @atlaskit/select
 * This will be cleaned up in DSP-17354, once @atlaskit/select is bumped
 */
React.createElement(RadioOption, props, /*#__PURE__*/React.createElement(Box, {
  xcss: mobileWrapperStyles
}, /*#__PURE__*/React.createElement(CustomOptionInternal, props.data)));